import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'
import imagePlaceholders from '../data/imagePlaceholders.json'

interface LazyImageProps extends BoxProps {
  src: string
  alt: string
  width?: number | string
  height?: number
  priority?: boolean
}

export const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  width,
  height,
  priority = false,
  ...props
}) => {
  const filename = src.split('/').pop()?.split('.')[0]
  const placeholder =
    filename && filename in imagePlaceholders
      ? imagePlaceholders[filename as keyof typeof imagePlaceholders]
      : undefined

  // Generate srcset for responsive images
  const generateSrcSet = () => {
    const sizes = ['small', 'medium', 'large']
    return sizes
      .map((size) => {
        const webpSrc = `/assets/${filename}-${size}.webp`
        const width = size === 'small' ? 640 : size === 'medium' ? 1024 : 1920
        return `${webpSrc} ${width}w`
      })
      .join(', ')
  }

  return (
    <picture>
      <source
        type="image/webp"
        srcSet={generateSrcSet()}
        sizes="(max-width: 640px) 640px, (max-width: 1024px) 1024px, 1920px"
      />
      <Box
        as="img"
        src={`/assets/${filename}.jpg`} // Fallback JPEG
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        width={width}
        height={height}
        style={{
          backgroundColor: '#f0f0f0',
          backgroundImage: `url(${placeholder})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        {...props}
      />
    </picture>
  )
}
